import { all, takeLatest } from 'lib/redux';
import {
  LOAD_DASHBOARD_PAGE, LOAD_RECENT_ORDERS, LOAD_ACCOUNT_SUMMARY, LOAD_COMPANY_INFO,
  LOAD_SUBSCRIPTION_DASHBOARD,
} from 'constants/ActionTypes';
import { loadDasboardPageSaga, loadRecentOrdersSaga } from './Dasboard.saga';
import { getAccountSummarySaga, getCompanyInfoSaga, getSubscriptionDashboardDataSaga } from '../userData/UserData.saga';

/**
 * Defines the watchers related to Dashboard Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(LOAD_DASHBOARD_PAGE, loadDasboardPageSaga),
    takeLatest(LOAD_RECENT_ORDERS, loadRecentOrdersSaga),
    takeLatest(LOAD_ACCOUNT_SUMMARY, getAccountSummarySaga),
    takeLatest(LOAD_SUBSCRIPTION_DASHBOARD, getSubscriptionDashboardDataSaga),
    takeLatest(LOAD_COMPANY_INFO, getCompanyInfoSaga),
  ]);
}
